import React from "react";
import { FaCheckCircle } from "react-icons/fa";

interface Step5Props {
  bookingReference: string;
  amount: number;
}

const Step5: React.FC<Step5Props> = ({ bookingReference, amount }) => {
  const isMobile = window.innerWidth <= 768;

  return (
    <div
      style={{
        padding: "10rem 1.5rem",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          maxWidth: 700,
          width: "100%",
          textAlign: "center",
        }}
      >
        <FaCheckCircle size={56} color="#22c55e" />
        <h1
          style={{
            fontSize: "2.5rem",
            marginTop: "1rem",
            color: "#111827",
            fontWeight: 700,
          }}
        >
          Booking Confirmed
        </h1>


        {/* Booking Reference Display */}
        <div style={{ margin: "2rem 0", backgroundColor: "#f3f4f6", padding: "1.5rem", borderRadius: "1rem", width: "60%", justifyContent: "center", marginLeft: "auto", marginRight: "auto" }}>
          <div
            style={{
              fontSize: isMobile ? 22 : "2rem",
              fontWeight: "bold",
              color: "#1F2937",
            }}
          >
            {bookingReference}
          </div>
          <div
            style={{
              marginTop: "0.5rem",
              fontSize: isMobile ? 12 : "1rem",
              color: "#6B7280",
              letterSpacing: "0.05em",
              textTransform: "uppercase",
            }}
          >
            Booking Reference
          </div>
        </div>
        
        <p
          style={{
            fontSize: "1.25rem",
            color: "#4B5563",
            marginTop: "1rem",
          }}
        >
          Thank you for your booking. A member of our team from Al Tayer Group will be in touch shortly to provide the final confirmation of your stay and share payment instructions.
        </p>
      </div>
    </div>
  );
};

export default Step5;
